exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".kayenta-edit-metric-modal .modal-content {\n  overflow: visible;\n}\n.kayenta-edit-metric-modal .effect-size-wrapper {\n  width: 100px;\n}\n", ""]);

